"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../Components/Button"));
var _Flex = _interopRequireDefault(require("../../Components/Flex"));
var _String = _interopRequireDefault(require("../../Components/String"));
var _useUpdated = _interopRequireDefault(require("../../Hooks/useUpdated"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Unhandled error view
 *
 * @package HOPS
 * @subpackage Errors
 * @copyright Heritage Operations Processing Limited
 */const UnhandledErrorView = props => {
  /**
   * When the route has changed, we want to clear the error state, 
   * so it doesn't persist continually even when navigating between views.
   * 
   * When rendered by a Sentry error boundary, we can call the 
   * `resetError()` prop it makes available to clear the error state now.
   */
  (0, _useUpdated.default)(() => props.resetError?.(), [props]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
    alignItems: "flex-start",
    px: 1,
    py: 1,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(props.EscapeHatch, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        bold: true,
        str: "Unhandled error",
        variant: "h6"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      gap: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: "Please try what you were doing again."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: "Refreshing the page might help resolve this error."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: "Contact HOPS if you keep seeing this message."
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      label: "Refresh",
      onClick: () => window.location.reload()
    })]
  });
};
var _default = exports.default = UnhandledErrorView;